import { useTranslation } from 'react-i18next';
import type { Profile } from 'models/user';
import { PlaceholderTrigger } from '../../placeholder-trigger';

type P = {
  onRequestInput: () => void;
  type: 'announcement' | 'post';
  viewer: Profile;
};

const CreatePostTriggerPlaceholder = ({ onRequestInput, type, viewer }: P) => {
  const { t } = useTranslation();

  return (
    <PlaceholderTrigger
      onClick={onRequestInput}
      placeholder={type === 'announcement' ? t('Create announcement') : t('Create post')}
      profilePhoto={viewer.profilePhoto}
    />
  );
};

export default CreatePostTriggerPlaceholder;
